// Re-Examination: ดึง Examination / Medical history จาก visit ก่อนหน้า
import { WasmHandler } from "react-lib/frameworks/WasmController";

import ReExaminationView from "issara-sdk/apis/ReExaminationView_apps_DEN";

import { GetArrayUniqueDataTp } from "./TreatmentTodayInterface";

type Handler = WasmHandler<any, any>;

// filter เริ่มต้นจาก encounter ของผู้ป่วย
export const getReExamFilterLists = (encounterList: any[]) => {
  const tpParams = { list: encounterList || [], isSelect: true };

  return {
    dateFilterListReExam: GetArrayUniqueDataTp({ ...tpParams, key: "started" }),
    dentistFilterListReExam: GetArrayUniqueDataTp({ ...tpParams, key: "doctor_name" }),
    clinicFilterListReExam: GetArrayUniqueDataTp({ ...tpParams, key: "division_name" }),
  };
};

export const getIdEncounter: Handler = async (controller, params) => {
  const state = controller.getState();
  if (state.reExaminationSub === "medicalHistory") {
    await controller.setProp("medicalHistoryList.chief_complaints", params.data?.chief_complaints || "");
    await controller.setProp("medicalHistoryList.present_illness", params.data?.present_illness || "");
    await controller.setProp("medicalHistoryList.additional_comment", params.data?.additional_comment || "");

    controller.setState({
      openModalReExamination: false,
      isModalReExaminationLoading: false,
      reExaminationSub: "",
    });
  }
  if (state.reExaminationSub === "examination") {
    let examinationList = [...state.clinicalFindingList];
    let newExamination = [];
    const [examination, error, network] = await ReExaminationView.post({
      apiToken: controller.apiToken,
      data: {
        from_encounter: params.id,
        to_encounter: state.encounterId,
      },
    });
    if (error) {
      console.log("Re examination error: ", error);
    } else {
      controller.handleEvent({
        message: "GetExamination",
        params: {
          encounter: state.encounterInfo.id,
          patient: state.patientDetail.id,
        },
      });
      controller.handleEvent({ message: "GetSuperToothList", params: { encounter: state.encounterInfo.id } });
    }
    controller.setState({
      openModalReExamination: false,
      isModalReExaminationLoading: false,
      reExaminationSub: "",
    });
  }

  controller.handleEvent({ message: "HandleResetFilterReExam", params: {} });
};

export const HandleResetFilterReExam: Handler = (controller, params) => {
  const { allReExamEncounterList } = controller.getState();
  const tpParams = { list: allReExamEncounterList || [], isSelect: true };
  const filterDate = GetArrayUniqueDataTp({ ...tpParams, key: "started" });
  const filterDentist = GetArrayUniqueDataTp({ ...tpParams, key: "doctor_name" });
  const filterClinic = GetArrayUniqueDataTp({ ...tpParams, key: "division_name" });

  controller.setState({
    reExamEncounterList: [...(allReExamEncounterList || [])],
    dateFilterListReExam: filterDate,
    dentistFilterListReExam: filterDentist,
    clinicFilterListReExam: filterClinic,
  });
};

export const SetReExamClinicFilter: Handler = (controller, params) => {
  const { filter } = params;

  const [searchFilter, statusFilter] = searchFilterTp(controller, {
    key: "clinicFilterListReExam",
    value: filter,
  });

  controller.setState({
    reExamEncounterList: searchFilter,
    openModalFilterReExamClinic: false,
    clinicFilterListReExam: statusFilter,
  });
};

export const SetReExamDateFilter: Handler = (controller, params) => {
  const { filter } = params;

  const [searchFilter, statusFilter] = searchFilterTp(controller, {
    key: "dateFilterListReExam",
    value: filter,
  });

  controller.setState({
    reExamEncounterList: searchFilter,
    openModalFilterReExamDate: false,
    dateFilterListReExam: statusFilter,
  });
};

export const SetReExamDentistFilter: Handler = (controller, params) => {
  const { filter } = params;

  const [searchFilter, statusFilter] = searchFilterTp(controller, {
    key: "dentistFilterListReExam",
    value: filter,
  });

  controller.setState({
    reExamEncounterList: searchFilter,
    openModalFilterReExamDentist: false,
    dentistFilterListReExam: statusFilter,
  });
};

const searchFilterTp: Handler = (controller, params) => {
  const { key, value } = params;
  const { allReExamEncounterList } = controller.getState();

  return allSearchFilterTp({ allList: allReExamEncounterList, data: controller.getState(), key, value });
};

const allSearchFilterTp = (params: { allList?: any[]; data: any; key: string; value: any[] }) => {
  const { data, key, value } = params;

  if (key) {
    data[key] = data[key].map((list: any) => {
      return {
        ...list,
        is_selected: value.includes(list.name),
      };
    });
  }

  const compareValue = (data: any, value: string) => {
    // if (!data?.[0] || !value) {
    //   return true;
    // }
    return data.find((acc: any) => acc.is_selected && acc.name === value);
  };

  const searchFilter = (params.allList || []).filter((item: any) => {
    return (
      compareValue(data.dateFilterListReExam, item.started) &&
      compareValue(data.dentistFilterListReExam, item.doctor_name) &&
      compareValue(data.clinicFilterListReExam, item.division_name)
    );
  });

  return [searchFilter, data[key]];
};

